export const loginEndPoint = () => {
  return `api/v1/auth/team-login`;
};

// new endpoints
export const memberEndPoint = () => {
  return `api/v1/member`;
};

export const studentDetails = (name:string) =>{
  return `/api/v1/member/listings/${name}`
}

export const applicationsEndPoint = (applicationId:string)=>{
  return `api/v1/member/applications/${applicationId}`
}
 export const facetEndPoint = (name:string) => {
    return `/api/v1/public/facets/${name} `;
  };


export const studentDetailsEndPoint = (studentId:string) =>{
  return `api/v1/member/students/${studentId}`;
}
export const allListingsEndPoint = (name:string) => {
  return `/api/v1/public/listings/${name}`;
};
export const newStudentsEndPoint = () => {
  return `/api/v1/member/new-students`;
};

export const verifyUserEndPoint = () => {
  return `/api/v1/auth/verify-user`;
};
// old 

export const switchStageEndPoint =()=>{
  return `api/v1/counsellor/stage`;
}

export const deleteRecommendationEndPoint =()=>{
  return `api/v1/counsellor/delete-recommendation`;
}

export const approvalEndPoint =()=>{
  return `api/v1/counsellor/approval`;
}
export const sendOTPEndPoint = () => {
  return `/api/v1/auth/forgot-password`;
};

export const verifyOTPEndPoint = () => {
  return `/api/v1/auth/verify-otp`;
};

export const switchActivityEndPoint = () =>{
  return `api/v1/counsellor/activity`;
}

export const recommendUniversityEndPoint = () =>{
  return `api/v1/counsellor/recommend`;
}

export const searchUniversityEndPoint = (search:string,page:number,perPage:number,institutions:number,universities:number,disciplines:number,subDisciplines:number,location:number) =>{
  return `/api/v1/public/university/?search=${search}&page=${page}&perPage=${perPage}&institutions=${institutions}&universities=${universities}&disciplines=${disciplines}&subDisciplines=${subDisciplines}&location=${location}`;
}
export const suggestPackageEndPoint = ()=>{
  return `api/v1/counsellor/package`
}
export const singleUniversityEndpoint = (universityId:string,currency:string) => {
  return `/api/v1/public/single_university/?id=${universityId}&currency=${currency}`;
};

export const singleCourceEndpoint = (courceId:string,currency:string) => {
  return `/api/v1/public/single_course/?id=${courceId}&currency=${currency}`;
};

// chats

export const fetchChatsEndPoint = () => {
  return `api/v1/communication/chats`;
};
export const seenEndPoint = (roomid:string) => {
  return `api/v1/communication/seen/${roomid}`;
};

export const postMessageEndPoint = () => {
  return "/api/v1/communication/message";
};

export const searchChatsEndPoint = (string:string) => {
  return `api/v1/communication/?search=${string}`;
};

export const chatDocsDownloadEndPoint = (id:string) =>{
  return `api/v1/communication/download-document/${id}`;
}
export const fetchAllMsgsEndPoint = (chatId:string) => {
  return `api/v1/communication/message/${chatId}`;
};
export const postRetriveChatEndPoit = (studentId:string) => {
  return `api/v1/communication/chats/${studentId}`;
};

// end

export const fetchNewStudentsEndpoint = () => {
  return "api/v1/counsellor/new-students";
};

export const acceptReqEndpoint = (studentId:string) => {
  return `api/v1/counsellor/new-students/${studentId}`;
};

// google calendar
export const googleSecretsEndpoint = () => {
  return `api/v1/counsellor/secrets`;
};


//get google calendar events
export const googleCalenderEventsEndpoint = () => {
  return `api/v1/member/events`;
};

//get google calendar events
export const googleFirstTimeCalenderEndpoint = () => {
  return `api/v1/member/google`;
};

export const googlecodeCalenderEndpoint = (code:string) => {
  return `api/v1/member/google/login/?code=${code}`;
};

export const leadCloseCall = () =>{
  return `api/v1/counsellor/close`
}

export const leadReopen = ()=>{
  return `api/v1/counsellor/reopen`
}

// coordinator endpoints
export const teamMemberEndPoint = () => {
  return `api/v1/process-coordinator`;
};

export const memberStudentEndPoint = (studentId:string) =>{
  return `api/v1/process-coordinator/students/${studentId}`;
}

export const coordinatorApplicationEndPoint = (applicationId:string) =>{
  return `api/v1/process-coordinator/applications/${applicationId}`;
}

export const coordinatorStatusSwitchEndPoint = () =>{
  return `api/v1/process-coordinator/switch-stage`;
}

export const addToChecklistEndPoint = () =>{
  return `api/v1/process-coordinator/add-to-checklist`;
}

export const editChecklistEndPoint = () =>{
  return `api/v1/process-coordinator/edit-in-checklist`;
}

export const resultEndPoint = () =>{
  return `api/v1/process-coordinator/result`;
}

export const revertDecisionEndPoint = () =>{
  return `api/v1/process-coordinator/revert-result`;
}

export const cancellationEndPoint = () =>{
  return `api/v1/process-coordinator/cancellation`;
}

export const downloadDocEndPoint = (id:string) =>{
  return `api/v1/process-coordinator/doc/${id}`;
}

export const updateStatusEndPoint = () =>{
  return `api/v1/process-coordinator/update-status`;
}

export const submittedEndPoint = () =>{
  return `api/v1/process-coordinator/submitted`;
}

export const uploadDocEndPoint = () =>{
  return `api/v1/process-coordinator/upload`;
}

export const admitReceivedEndPoint = () =>{
  return `api/v1/process-coordinator/admitReceived`;
}

export const rejectEndPoint = () =>{
  return `api/v1/process-coordinator/reject`;
}

export const applicationListingEndPoint = () => {
  return `api/v1/process-coordinator/application-listing`;
}

export const createBlogEndPoint = () =>{
  return `api/v1/member/blog`;
}

export const createCountryEndPoint = () =>{
  return `api/v1/member/destination`;
}
export const editCountryEndPoint = (id:string) =>{
  return `api/v1/member/destination/${id}`;
}
export const deleteCountryEndPoint = (id:string) =>{
  return `api/v1/member/destination/${id}`;
}

export const createTeamEndPoint = () =>{
  return `api/v1/auth/team-register`;
}

export const createUserEndPoint = () =>{
  return `/api/v1/counsellor/register-student `;
}

export const updateUserEndPoint = () =>{
  return `/api/v1/counsellor/update-student `;
}

export const adminStudentsEndPoint = () => {
  return `/api/v1/admin/students`;
};

export const adminStudentSearchEndPoint = (query: string) => {
  return `/api/v1/admin/search?search=${encodeURIComponent(query)}`;
};

export const adminStudentDetailsEndPoint = (studentId: string) => {
  return `/api/v1/admin/student/${studentId}`;
};

export const adminCounsellorsEndPoint = () => {
  return `/api/v1/admin/counsellors`;
};

export const adminStudentTransferEndPoint = () => {
  return `/api/v1/admin/student-transfer`;
};



